import React, { useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import BASE_URL from "../config"; // Import BASE_URL from config.js

const CareerForm = () => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    position: "",
    attachment: null,
  });
  const [validationErrors, setValidationErrors] = useState({});
  const [loading, setLoading] = useState(false); // Add loading state

  const handleInputChange = (e) => {
    const { id, value, files } = e.target;
    setFormData({
      ...formData,
      [id]: files ? files[0] : value,
    });

    setValidationErrors((prevErrors) => {
      const { [id]: removedError, ...remainingErrors } = prevErrors;
      return remainingErrors;
    });
  };

  const handleFocus = (fieldId) => {
    setValidationErrors((prevErrors) => {
      const { [fieldId]: removedError, ...remainingErrors } = prevErrors;
      return remainingErrors;
    });
  };

  const validateStep = (isSubmit = false) => {
    const errors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9+()]+$/;

    if (step === 1 || isSubmit) {
      if (!formData.name.trim()) {
        errors.name = "Name is required.";
      }
    }
    if (step === 2 || isSubmit) {
      if (!formData.email.trim()) {
        errors.email = "Email is required.";
      } else if (!emailRegex.test(formData.email)) {
        errors.email = "Invalid email format.";
      }
      if (!formData.phone.trim()) {
        errors.phone = "Phone number is required.";
      } else if (!phoneRegex.test(formData.phone)) {
        errors.phone = "Phone number can only contain numbers.";
      }
    }
    if (step === 3 || isSubmit) {
      if (!formData.position.trim()) {
        errors.position = "Position name is required.";
      }
      if (!formData.attachment) {
        errors.attachment = "Attachment is required.";
      }
    }
    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleNext = () => {
    if (validateStep()) {
      setStep(step + 1);
      setValidationErrors({});
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateStep(true) && !loading) { // Prevent submission if already loading
      setLoading(true); // Set loading to true
      const formDataToSend = new FormData();
      formDataToSend.append("name", formData.name);
      formDataToSend.append("email", formData.email);
      formDataToSend.append("phone", formData.phone);
      formDataToSend.append("position", formData.position);
      if (formData.attachment) {
        formDataToSend.append("resume_path", formData.attachment); // Ensure file is included
      }

      try {
        const response = await axios.post(`${BASE_URL}api/jobs/apply`, formDataToSend, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        Swal.fire("Success", response.data.message, "success");
        setFormData({
          name: "",
          email: "",
          phone: "",
          position: "",
          attachment: null,
        });
        setStep(1);
      } catch (error) {
        console.error("Error response:", error.response?.data); // Log server error response
        Swal.fire("Error", error.response?.message || "Something went wrong", "error");
      } finally {
        setLoading(false); // Reset loading state
      }
    }
  };

  return (
    <form className="career-custom-form" onSubmit={handleSubmit}>
      {step === 1 && (
        <div className="career-custom-form-group">
          <input
            type="text"
            id="name"
            className="career-custom-input"
            placeholder="Enter Your Name"
            value={formData.name}
            onChange={handleInputChange}
            onFocus={() => handleFocus("name")}
          />
          {validationErrors.name && <small className="text-danger">{validationErrors.name}</small>}
          <button
            type="button"
            className="career-custom-submit-button career-custom-next-button"
            onClick={handleNext}
          >
            NEXT
          </button>
        </div>
      )}
      {step === 2 && (
        <>
          <div className="career-custom-form-group">
            <input
              type="email"
              id="email"
              className="career-custom-input"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleInputChange}
              onFocus={() => handleFocus("email")}
            />
            {validationErrors.email && <small className="text-danger">{validationErrors.email}</small>}
          </div>
          <div className="career-custom-form-group">
            <input
              type="tel"
              id="phone"
              className="career-custom-input"
              placeholder="Phone Number"
              value={formData.phone}
              onChange={handleInputChange}
              onFocus={() => handleFocus("phone")}
            />
            {validationErrors.phone && <small className="text-danger">{validationErrors.phone}</small>}
          </div>
          <button
            type="button"
            className="career-custom-submit-button"
            onClick={handleNext}
          >
            NEXT
          </button>
        </>
      )}
      {step === 3 && (
        <>
          <div className="career-custom-form-group">
            <input
              type="text"
              id="position"
              className="career-custom-input"
              placeholder="Position Name"
              value={formData.position}
              onChange={handleInputChange}
              onFocus={() => handleFocus("position")}
            />
            {validationErrors.position && <small className="text-danger">{validationErrors.position}</small>}
          </div>
          <div className="career-custom-form-group">
            <input
              type="file"
              id="attachment"
              className="career-custom-input"
              accept=".pdf"
              onChange={handleInputChange}
              onFocus={() => handleFocus("attachment")}
            />
            {validationErrors.attachment && <small className="text-danger">{validationErrors.attachment}</small>}
          </div>
          <button
            type="submit"
            className="career-custom-submit-button"
            disabled={loading} // Disable button when loading
          >
            {loading ? "Submitting..." : "SUBMIT"} {/* Show loading text */}
          </button>
        </>
      )}
    </form>
  );
};

export default CareerForm;
